/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'service-level-premium-32x32': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g fill-rule="evenodd" _fill="#F4633A"><path pid="0" d="M16 1L4 7l12 6 12-6z"/><path pid="1" d="M25 11.5l3 1.5-12 6-12-6 3-1.5 9 4.5 9-4.5z"/><path pid="2" d="M25 17.5l3 1.5-12 6-12-6 3-1.5 9 4.5 9-4.5z"/><path pid="3" d="M25 23.5l3 1.5-12 6-12-6 3-1.5 9 4.5 9-4.5z"/></g>'
  }
})
